export default {
    "name": "UpdateInventoryType",
    "kind": "HoudiniMutation",
    "hash": "c66ceb1784f4fd6ddd177677f367c3ed67f067ac4076e9530ce8c4c466aba516",

    "raw": `mutation UpdateInventoryType($input: InventoryTypeUpdate!) {
  updateInventoryType(input: $input) {
    active
    id
    name
    setId
    vehicle
    taxCode
  }
}
`,

    "rootType": "Mutation",
    "stripVariables": [],

    "selection": {
        "fields": {
            "updateInventoryType": {
                "type": "InventoryType",
                "keyRaw": "updateInventoryType(input: $input)",

                "selection": {
                    "fields": {
                        "active": {
                            "type": "Boolean",
                            "keyRaw": "active",
                            "visible": true
                        },

                        "id": {
                            "type": "UInt",
                            "keyRaw": "id",
                            "visible": true
                        },

                        "name": {
                            "type": "String",
                            "keyRaw": "name",
                            "visible": true
                        },

                        "setId": {
                            "type": "Int",
                            "keyRaw": "setId",
                            "nullable": true,
                            "visible": true
                        },

                        "vehicle": {
                            "type": "Boolean",
                            "keyRaw": "vehicle",
                            "visible": true
                        },

                        "taxCode": {
                            "type": "String",
                            "keyRaw": "taxCode",
                            "visible": true
                        }
                    }
                },

                "visible": true
            }
        }
    },

    "pluginData": {
        "houdini-svelte": {
            "isManualLoad": true
        }
    },

    "input": {
        "fields": {
            "input": "InventoryTypeUpdate"
        },

        "types": {
            "InventoryTypeUpdate": {
                "active": "Boolean",
                "id": "Int",
                "name": "String",
                "partListAuthorityId": "Int",
                "pickable": "Boolean",
                "publicAllowed": "Boolean",
                "requireSerialization": "Boolean",
                "setId": "Int",
                "taxCode": "String",
                "typeLabel1": "String",
                "typeLabel2": "String",
                "typeLabel3": "String",
                "typeLabel4": "String",
                "useManufacturer": "Boolean",
                "vehicle": "Boolean"
            }
        },

        "defaults": {},
        "runtimeScalars": {}
    }
};

"HoudiniHash=7fea57c9ecc928b8c3accb5e118abdd374462a4a67d577211b7b2449301f1072";